import { createStyles, Theme } from '@material-ui/core/styles';
import { StyleRules } from '@material-ui/core/styles/withStyles';
import { app } from '../../../../../theme';

const styles = (theme: Theme): StyleRules<string> => createStyles({
  root: {
    [theme.breakpoints.up('sm')]: {
      width: theme.breakpoints.values.sm,
    },
    backgroundColor: theme.palette.background.default,
  },
  formControl: app.forms.formControl(theme),
  formControlText: {
    ...app.forms.formControl(theme),
    marginTop: 5,
  },
  details: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
  },
  paper: {
    display: 'flex',
    marginTop: theme.spacing(1),
    padding: theme.spacing(2),
    flexDirection: 'column',
  },
  tabItem: {
    color: theme.palette.primary.main,
    fontSize: 12,
    fontWeight: 600,
  },
  command: {
    marginTop: theme.spacing(1.5),
    display: 'flex',
    justifyContent: 'space-between',
  },
  actionButton: {
    [theme.breakpoints.up('sm')]: {
      minWidth: 150,
    },
    height: 36,
  },
});

export default styles;
